<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${unitOfMeasure.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="unitOfMeasure" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "unit-of-measure-view-logs",

  components: { LogListTable },

  props: ["unitOfMeasure"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    unitOfMeasure(unitOfMeasure) {},
  },
};
</script>
